import { render, staticRenderFns } from "./newsandinformation.vue?vue&type=template&id=0adcae8e&scoped=true&"
import script from "./newsandinformation.vue?vue&type=script&lang=js&"
export * from "./newsandinformation.vue?vue&type=script&lang=js&"
import style0 from "./newsandinformation.vue?vue&type=style&index=0&id=0adcae8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adcae8e",
  null
  
)

export default component.exports